import { FormControlLabel, Radio, RadioGroup, Typography, Grid } from '@mui/material'
import React, { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { ErrorMessage } from '../../../components/styled/uiComponents'
import { CommonFormSectionProps } from '../../../types'
import { isJulyMembershipStartAvailable } from '../../../utils/membershipChecks'
import { membershipStartingTimeFormLabels } from '../../../utils/stringConstants'

const FIELD_NAME = 'membership_starts'

const MembershipStartsField: React.FC<CommonFormSectionProps> = ({ control, errors }) => {
  const { setValue, watch } = useFormContext()
  const membershipStarts = watch(FIELD_NAME)
  const showJulyOption = isJulyMembershipStartAvailable()

  useEffect(() => {
    if (!showJulyOption && membershipStarts === 'BEGINNING_OF_HALF_YEAR') {
      setValue(FIELD_NAME, 'WHEN_APPROVED')
    }
  }, [showJulyOption, membershipStarts, setValue])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant='h5' color='primary'>
          Jäsenyyden aloitusajankohta*
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Controller
          name={FIELD_NAME}
          control={control}
          render={({ field: { onChange, value } }) => (
            <RadioGroup onChange={e => onChange(e.target.value)} value={value}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControlLabel
                    value='WHEN_APPROVED'
                    control={<Radio />}
                    label={membershipStartingTimeFormLabels.WHEN_APPROVED}
                  />
                </Grid>
                {showJulyOption && (
                  <Grid item xs={12}>
                    <FormControlLabel
                      value='BEGINNING_OF_HALF_YEAR'
                      control={<Radio />}
                      label={membershipStartingTimeFormLabels.BEGINNING_OF_HALF_YEAR}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <FormControlLabel
                    value='BEGINNING_OF_CALENDAR_YEAR'
                    control={<Radio />}
                    label={membershipStartingTimeFormLabels.BEGINNING_OF_CALENDAR_YEAR}
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          )}
        />
      </Grid>
      <ErrorMessage>{errors.membership_starts?.message}</ErrorMessage>
    </Grid>
  )
}
export default MembershipStartsField
